<template>
    <TransitionRoot appear as="template" :show="isShowing">
        <Dialog class="relative z-10" @close="close">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg md:max-w-xl lg:max-w-2xl xl:max-w-3xl sm:p-6">
                            <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                <button type="button" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" @click="close">
                                    <span class="sr-only">Close</span>
                                    <XIcon class="h-6 w-6" aria-hidden="true" />
                                </button>
                            </div>
                            <div class="sm:flex sm:items-center">
                                <div class="mt-3 sm:mt-0 ml-auto mr-auto">
                                    <FunnerixWidget :slug="funnelSlug" disable-hash disable-scrolling compact />
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup lang="ts">
import { useVueExitIntent } from 'vue-exit-intent'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XIcon } from '@heroicons/vue/solid'
import FunnerixWidget from '../FunnelWidget/AppWidget.ce.vue'
import {onMounted} from "vue";

const props = defineProps({
    slug: {
        type: String
    },
    funnelSlug: {
        type: String
    },
    instantOpen: {
        type: Boolean,
        default: false,
    }
})

const options = {
    LSItemKey: 'funnerix-box-'+props.slug,
    handleScrollBars: true,
    repeatAfterDays: 0,
    scrollPercentageToTrigger: 0,
    delaySecondsAndTrigger: 0,
    triggerOnExitIntent: true,
    touchDeviceSensitivity: 15,
    scrollDebounceMillis: 300,
    triggerOnPageLoad: props.instantOpen,
}

const { isShowing,
    isAllowedToGetTriggered,
    isUnsubscribed,
    close,
    resetState,
    unsubscribe
} = useVueExitIntent(options);

onMounted( () => {
    console.log("I am living in a box")
    console.log(props.slug)
    resetState()
})
</script>
